import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';

export interface RecordsResponse {
  totalCount: number;
  results: Record<string, any>[];
}

@Injectable({
  providedIn: 'root',
})
export class PropertySetWidgetService {
  constructor(private client: HttpClient) {}

  public deletePropertiesToPropertySet(id: number, usageIds: number[]): Observable<any> {
    return this.client.delete(`/api/propertyset/${id}/records`, { body: usageIds }).pipe(take(1));
  }

  public fetch(fingerprints: string[]): Observable<any> {
    return this.client.post<any>('/api/propertysets', fingerprints).pipe(take(1));
  }

  public recordSearch(request): Observable<RecordsResponse> {
    return this.client.post<RecordsResponse>(`/api/search/record`, request).pipe(take(1));
  }
}
